import { StyleSheet } from "react-native";

export default StyleSheet.create({
    modal: {
        backgroundColor: "#00000099"
    },
    pickerHeader: {
        width: "100%",
        height: 48,
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "white",
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12
    },

    cancel: {
        paddingHorizontal: 12,
        paddingVertical: 10,
        textAlign: "center",
        fontSize: 16,
        color: "#999999"
    },

    title: {
        fontSize: 16,
        fontWeight: "bold",
        color: "#222222"
    },

    confirm: {
        paddingHorizontal: 12,
        paddingVertical: 10,
        fontSize: 16,
        color: "#00CAD8"
    },

    pickerContainer: {
        height: 216,
        backgroundColor: "white"
    }
});
